import {CustomList} from "./CustomList";


export default {
    list: CustomList,
    
};
